import sliceCreator from '../../index.js';
import {GET_ORDER} from '../../../constants/index.js';
const _updateOrderAction = sliceCreator('GET_ORDER',GET_ORDER, 'put');

const { asyncAction: updateOrderAction, reducer, clearData: clearupdateOrderAction } = _updateOrderAction;

export default reducer;

export {
    updateOrderAction,
    clearupdateOrderAction
}


